import classNames from "classnames";
import ChevronDown from "../../../assets/icons/chevron-down.svg?react";
import ChevronUp from "../../../assets/icons/chevron-up.svg?react";
import styles from "./TableSortIcon.module.scss";

export type TableSortIconProps = {
  order?: "asc" | "desc" | null;
  className?: string;
};

export function TableSortIcon({ order, className }: TableSortIconProps) {
  return (
    <span className={classNames(styles.sortIcon, className)}>
      <ChevronUp
        className={classNames(styles.chevron, {
          [styles.active]: order === "asc",
        })}
      />
      <ChevronDown
        className={classNames(styles.chevron, {
          [styles.active]: order === "desc",
        })}
      />
    </span>
  );
}
